import React, { useRef } from 'react'
import { useVarList } from './charts/hooks/useVarList'
import CorrelationPanel from './charts/CorrelationPanel'
import { HelpCircle } from 'lucide-react'
import { useIsMobile } from '../../utils/hooks/useIsMobile'
import { useBodyScrollLock } from '../../utils/hooks/useBodyScrollLock'

type Props = {
    token: string
    onClose: () => void
}

/**
 * Monta useVarList/CorrelationPanel só quando aberto — evita fetch de
 * /api/graficos/variaveis para quem nunca abre a análise de correlação.
 */
const CorrelationDrawer: React.FC<Props> = ({ token, onClose }) => {
    const { categorias } = useVarList(token)
    const correlationInfoRef = useRef<(() => void) | null>(null)
    const isMobile = useIsMobile()
    useBodyScrollLock()

    return (
        <div onClick={onClose}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 300, backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div onClick={e => e.stopPropagation()}
                style={{
                    width: isMobile ? '100vw' : 560, maxWidth: isMobile ? '100vw' : '90vw',
                    height: isMobile ? '100dvh' : 'auto', maxHeight: isMobile ? '100dvh' : '85vh',
                    background: 'linear-gradient(180deg, #1a2535 0%, #16202D 100%)',
                    border: isMobile ? 'none' : '1px solid rgba(255,255,255,0.09)',
                    borderRadius: isMobile ? 0 : 20,
                    boxShadow: isMobile ? 'none' : '0 20px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.06)',
                    display: 'flex', flexDirection: 'column', overflow: 'hidden',
                }}>
                {/* Header fixo */}
                <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid rgba(255,255,255,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
                    <div>
                        <div style={{ fontFamily: 'Montserrat,sans-serif', fontWeight: 700, fontSize: 16, background: 'linear-gradient(45deg, rgb(62,147,216), rgb(76,185,49))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                            Análise de Correlação
                        </div>
                        <div style={{ fontFamily: 'Nunito,sans-serif', fontSize: 12, color: 'rgba(255,255,255,0.35)', marginTop: 2 }}>
                            Identifique relações entre variáveis da usina
                        </div>
                    </div>
                    {/* ? e ✕ lado a lado */}
                    <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => correlationInfoRef.current?.()}
                            title="O que é correlação?"
                            style={{ background: 'rgba(255,255,255,0.06)', border: 'none', color: 'rgba(255,255,255,0.45)', width: isMobile ? 44 : 30, height: isMobile ? 44 : 30, borderRadius: 8, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                        >
                            <HelpCircle size={isMobile ? 20 : 15} strokeWidth={1.8} />
                        </button>
                        <button onClick={onClose}
                            title="Fechar"
                            style={{ background: 'rgba(255,255,255,0.06)', border: 'none', color: 'rgba(255,255,255,0.45)', width: isMobile ? 44 : 30, height: isMobile ? 44 : 30, borderRadius: 8, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: isMobile ? 20 : 16, flexShrink: 0 }}
                        >✕</button>
                    </div>
                </div>
                {/* Conteúdo scrollável */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px 32px' }}>
                    <CorrelationPanel token={token} categorias={categorias} infoRef={correlationInfoRef} />
                </div>
            </div>
        </div>
    )
}

export default CorrelationDrawer
